import { render, staticRenderFns } from "./multiple-choice.vue?vue&type=template&id=0ec4ab86&scoped=true&"
import script from "./multiple-choice.vue?vue&type=script&lang=js&"
export * from "./multiple-choice.vue?vue&type=script&lang=js&"
import style0 from "./multiple-choice.vue?vue&type=style&index=0&id=0ec4ab86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4ab86",
  null
  
)

component.options.__file = "multiple-choice.vue"
export default component.exports